export default "__VITE_ASSET__np$fheRO__"